import React from 'react';
import CreateTab from '../components/CreateTab';

export default function TeacherCreatePage() {
    return (
        <div className="space-y-6" data-testid="teacher-create-page">
            <div>
                <h1 className="text-3xl sm:text-4xl font-black tracking-tight">Create a Question</h1>
                <p className="text-sm text-zinc-500 mt-1">Generate a question + AI mark scheme, then send it to a class as an assignment.</p>
            </div>
            <CreateTab />
        </div>
    );
}
